import {
    NinchatActionType,
    NinchatDescribeTranscriptAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatTranscriptFoundEvent} from 'api/types/events'

import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const describeTranscript = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeTranscriptAction}`,
    async (arg: NinchatActionParams<NinchatDescribeTranscriptAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeTranscriptAction

        try {
            return await ninchatClient.send(params) as NinchatTranscriptFoundEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
